import { makeStyles, withStyles, TableCell } from "@material-ui/core";


export default makeStyles((theme) => ({
    close: {
        "&:hover": {
            cursor: "pointer",
        },
    },
    linkPopper: {
        backgroundColor: theme.palette.common.white,
        boxShadow: "rgba(0, 0, 0, 0.1) 0px 2px 8px 0px",
        color: theme.palette.grey[700],
        fontWeight: 600,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: 16,
        borderRadius: 4,
    },
    noImageBackground: {
        display: "flex",
        backgroundColor: theme.palette.common.white,
        margin: "auto",
        height: 56,
        width: 56,
        borderRadius: "50%",
    },
    thumbnail: {
        display: "flex",
        backgroundColor: theme.palette.grey[300],
        height: 90,
        width: "100%",
        objectFit: "cover",
        borderRadius: 4,
    },
}));

export const Cell = withStyles(theme => ({
    root: {
        "& div": {
            color: theme.palette.grey[700],
            fontFamily: "source sans pro",
            fontSize: 16,
            fontWeight: 600,
        },
        "& div + div": {
            fontWeight: 400,
        },
    },
}))(TableCell);
